import { render } from "./Blocks.vue?vue&type=template&id=3fc3bb9c&scoped=true"
import script from "./Blocks.vue?vue&type=script&lang=js"
export * from "./Blocks.vue?vue&type=script&lang=js"

import "./Blocks.vue?vue&type=style&index=0&id=3fc3bb9c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3fc3bb9c"

export default script